window.HIS = {

    init:function() {
        // Auto-close alerts
        setTimeout(function() { $(".alerts-container .alert").alert('close'); }, 3000);
    }
};

$(document).ready(function(){
    HIS.init();
});
